import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionDireccionesListaItem {
  constructor (FacturacionConfiguracionClientesDirecciones) {
    this.FacturacionConfiguracionClientesDirecciones = FacturacionConfiguracionClientesDirecciones
    this.eliminando = false
    this.onDelete = null
    this.onSeleccionar = null
    this.data = null
  }

  seleccionar () {
    this.onSeleccionar({$event: {indice: this.data.indice}})
  }

  eliminar () {
    this.eliminando = true

    return this.FacturacionConfiguracionClientesDirecciones.delete(this.data.kardex_id, this.data.indice)
      .then(() => (this.onDelete({$event: {data: this.data}})))
      .finally(() => (this.eliminando = false))
  }

}

module.component('clienteInformacionDireccionesListaItem', {
  controller: ClienteInformacionDireccionesListaItem,
  template,
  bindings: {
    data: '<',
    showEliminar: '<',
    onDelete: '&',
    onSeleccionar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/direcciones/lista/item/component.js